import { render, staticRenderFns } from "./BouncedEmail.vue?vue&type=template&id=01ea5971&"
import script from "./BouncedEmail.vue?vue&type=script&lang=babel&"
export * from "./BouncedEmail.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports